import { isAddress } from 'web3-utils'
import BigNumber from 'bignumber.js'
import { BLOCKCHAIN_BINANCE, NAME_BY_BLOCKCHAIN } from '../../constants/blockchain'
import {
  eventEmitter,
  getAddress,
  getChainId, isMetamaskInstalled
} from './../../servicies/metamask'
import { awaitTransactionStatusAppliedBlockchain } from '../../servicies/transaction'
import {
  // timeLock,
  // timeLocksLength,
  timeSmoothLock,
  timeSmoothLocksLength,
  getAmounts,
  withdrawAvailableTokens,
} from '../../servicies/TimeLocker'
import TimeSmoothLock from './../../models/TimeSmoothLock'
import Switch from './../../components/Switch/Switch.vue'
import TotalInfo from './TotalInfo/TotalInfo.vue'
import Stages from './Stages/Stages.vue'
import Menu from '../../components/Menu/Menu.vue'

export default {
  components: {
    'my-switch': Switch,
    TotalInfo,
    Stages,
    Menu
  },
  computed: {
    availableFormatted () {
      return new BigNumber(this.availableAmount).dividedBy(10 ** 8).toFixed(2)
    },
    lockedFormatted () {
      return new BigNumber(this.lockedAmount).isGreaterThan(0)
        ? new BigNumber(this.lockedAmount).dividedBy(10 ** 8).toFixed(2)
        : null
    },
    totalFormattedPlusManualTransfer () {
      let sum = new BigNumber(0)
      for (const item of this.timeSmoothLocks) {
        sum = sum.plus(item.amountPlusManualTransfer)
      }
      return sum.dividedBy(10 ** 8).toFixed(2)
    },
    totalFormatted () {
      return new BigNumber(this.availableAmount).plus(this.lockedAmount).dividedBy(10 ** 8).toFixed(2)
    },
    isChainIdCorrect () {
      return this.chainId === BLOCKCHAIN_BINANCE
    },
    showInfoBlocks () {
      if (this.tab === 0 && isAddress(this.typedAddress) && this.loadInfoClicked) {
        return true
      }
      if (this.tab === 1 && this.connected) {
        return true
      }
      return false
    },
    withdrawAvailable () {
      return (this.tab === 1 && new BigNumber(this.availableAmount).isGreaterThan(0)) && this.isChainIdCorrect
    }
  },
  data () {
    return {
      tab: 0,
      loadInfoClicked: false,
      typedAddress: '',
      snackbarOpen: false,
      snackbarText: '',
      items: ['Type Address', 'Metamask Connect'],
      NAME_BY_BLOCKCHAIN,
      connected: false,
      address: null,
      chainId: null,
      timeLocks: [],
      timeSmoothLocks: [],
      availableAmount: null,
      lockedAmount: null,
      tablesLoading: false,
      withdrawing: false,
      loaded: false,
      openMenu: false,
    }
  },
  methods: {
    toogleMenu () {
      this.openMenu = !this.openMenu
    },
    setTab (tab) {
      this.loadInfoClicked = false
      this.tab = tab
      if (tab === 1) {
        this.checkLocks()
      }
    },
    async connect () {
      if (!isMetamaskInstalled()) {
        this.snackbarText = 'You need to install metamask'
        this.snackbarOpen = true
        return
      }
      const addressListener = async (addresses) => {
        this.address = addresses[0]
        if (this.tab === 1) {
          this.checkLocks()
        }
      }
      const chainIdListener = async (chainId) => {
        this.chainId = chainId
      }
      const connectListener = async () => {
        this.connected = true
      }
      const disconnectListener = async () => {
        this.connected = false
      }
      eventEmitter.on('accountsChanged', addressListener)
      eventEmitter.on('chainChanged', chainIdListener)
      eventEmitter.on('connect', connectListener)
      eventEmitter.on('disconnect', disconnectListener)
      eventEmitter.on('start', connectListener)
      eventEmitter.on('stop', disconnectListener)
      this.address = await getAddress()
      this.chainId = await getChainId()
      if (this.address && this.chainId) {
        this.connected = true
        this.checkLocks()
      }
    },
    async checkLocks () {
      const tab = this.tab
      this.loaded = false
      let address = null
      this.timeLocks = []
      this.timeSmoothLocks = []
      this.tablesLoading = true
      if (this.tab === 0) {
        address = this.typedAddress
      }
      if (this.tab === 1) {
        address = this.address
      }
      if (!address) {
        this.tablesLoading = false
        return
      }
      try {
        const { availableAmount, lockedAmount } = await getAmounts(address)
        this.availableAmount = availableAmount
        this.lockedAmount = lockedAmount
        // const countLocks = await timeLocksLength(address)
        // if (countLocks > 0) {
        //   for (let i = 0; i < countLocks; i++) {
        //     const data = await timeLock(address, i)
        //     this.timeLocks.push(new TimeLock(data))
        //   }
        // }
        const countSmoothLocks = await timeSmoothLocksLength(address)
        if (countSmoothLocks > 0) {
          const items = []
          for (let i = 0; i < countSmoothLocks; i++) {
            const data = await timeSmoothLock(address, i)
            items.push(new TimeSmoothLock(data))
          }
          if (tab === this.tab) {
            this.timeSmoothLocks = items
          }
        }
      } catch (err) {
        console.error(err)
      } finally {
        this.tablesLoading = false
        this.loaded = true
      }
    },
    async loadInfoForAddress () {
      if (!await this.$refs.main.validate()) return false
      this.loadInfoClicked = true
      this.checkLocks()
    },
    async withdraw () {
      try {
        this.withdrawing = true
        const tx = await withdrawAvailableTokens({ from: this.address })
        await awaitTransactionStatusAppliedBlockchain({ blockchain: BLOCKCHAIN_BINANCE, tx })
        this.checkLocks()
      } catch (err) {
        this.snackbarText = err?.message || 'Unrecognized error when claiming tokens'
        this.snackbarOpen = true
        console.error(err)
      } finally {
        this.withdrawing = false
      }
    }
  },
  mounted () {
    // this.loadInfoForAddress()
  }
}
